import { type Program, type Topic, createActivity } from 'models';
import { Modal, message } from 'ui';
import type { Activity } from 'models/activity';
import { ActivityForm } from '../form';
import { useCreateActivityMutation } from '../queries/mutations';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onRequestReturn?: () => void;
  onSuccess: () => Promise<void>;
  preSelectedProgramTopic?: Topic;
  program: Program;
};

const CreateActivity = ({ isOpened, onCancel, onRequestReturn, onSuccess, preSelectedProgramTopic, program }: P) => {
  const { isPending, mutate } = useCreateActivityMutation();

  const onSubmit = (activity: Activity) => {
    mutate(activity, {
      onError() {
        message.error('Failed to create activity.');
      },
      async onSuccess() {
        await onSuccess();
        message.success('Activity was created.');
      },
    });
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Add New Activity" width="medium">
      <Modal.HugContent>
        <ActivityForm
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Matches the BE activity payload's field names
          activity={createActivity({ programs_topic: preSelectedProgramTopic })}
          loading={isPending}
          onRequestReturn={onRequestReturn}
          onSubmit={onSubmit}
          program={program}
        />
      </Modal.HugContent>
    </Modal>
  );
};

export default CreateActivity;
